"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RightType = exports.RightStatus = void 0;
var RightStatus;
(function (RightStatus) {
    RightStatus["ACTIVE"] = "Active";
    RightStatus["RELEASED"] = "Released";
    RightStatus["EXPIRED"] = "Expired";
})(RightStatus || (exports.RightStatus = RightStatus = {}));
var RightType;
(function (RightType) {
    RightType["TWO_D_ARTWORK"] = "2D Artwork";
    RightType["CELEBRITY_GUARANTEE"] = "Celebrity Guarantee";
    RightType["CHARACTER_LICENSE"] = "Character License";
    RightType["CLEARANCE_LIMITATION"] = "Clearance Limitation";
    RightType["CUSTOMER_PROVIDED_MATERIALS"] = "Customer Provided Materials";
    RightType["DORMANCY_FEES"] = "Dormancy Fees";
    RightType["FILM_FOOTAGE_LICENSE"] = "Film Footage License";
    RightType["FONT_LICENSE"] = "Font License";
    RightType["ILLUSTRATOR"] = "Illustrator";
    RightType["INFLUENCER"] = "Influencer";
    RightType["MUSIC_DEMO_FEE"] = "Music Demo Fee";
    RightType["MUSIC_MASTER_LICENSE"] = "Music Master License";
    RightType["MUSIC_PUBLISHING_LICENSE"] = "Music Publishing License";
    RightType["MUSIC_MASTER_AND_PUBLISHING_LICENSE"] = "Music Master and Publishing License";
    RightType["NON_UNION_BACKGROUND_EXTRA"] = "Non-Union Background Extra";
    RightType["NON_UNION_CHARACTER_VOICE"] = "Non-Union Character Voice";
    RightType["NON_UNION_DRIVER"] = "Non-Union Driver";
    RightType["NON_UNION_FEATURED_EXTRA"] = "Non-Union Featured Extra";
    RightType["NON_UNION_INFLUENCER"] = "Non-Union Influencer";
    RightType["NON_UNION_ON_CAMERA_PRINCIPAL"] = "Non-Union On-Camera Principal";
    RightType["NON_UNION_OTHER"] = "Non-Union Other";
    RightType["NON_UNION_VOICEOVER"] = "Non-Union Voiceover";
    RightType["NON_UNION_AGREEMENT"] = "Non-Union Agreement";
    RightType["ORIGINAL_MUSIC_LICENSE"] = "Original Music License";
    RightType["ORIGINAL_MUSIC_NON_AFM"] = "Original Music (Non-AFM)";
    RightType["OTHER"] = "Other";
    RightType["PHOTOGRAPHER"] = "Photographer";
    RightType["PRINCIPAL_MODEL"] = "Principal Model";
    RightType["PROMOTIONAL_LICENSE"] = "Promotional License";
    RightType["RIGHT_OF_PUBLICITY"] = "Right of Publicity";
    RightType["SPORTING_EVENT_FOOTAGE_LICENSE"] = "Sporting Event Footage License";
    RightType["STOCK_ARTWORK_2D"] = "Stock Artwork (2D)";
    RightType["STOCK_FILM_FOOTAGE"] = "Stock Film Footage";
    RightType["STOCK_MUSIC"] = "Stock Music";
    RightType["STOCK_PHOTO"] = "Stock Photo";
    RightType["TERM_GUARANTEE"] = "Term Guarantee";
    RightType["UNION_TALENT"] = "Union Talent";
})(RightType || (exports.RightType = RightType = {}));
//# sourceMappingURL=right-types.js.map